import { stringify } from 'query-string';
import getSessionId from './lib/getSessionId';
import { apiUrl } from './services/env';
import request, { fetcher, suspenseFetcher } from './services/request';

function createSubmission(pageId, data, token = null) {
  return request(`${apiUrl}/checkout/${pageId}/submissions`, token, {
    body: JSON.stringify(data),
    method: 'POST',
  });
}

function createPayment(pageId, data, token = null) {
  return request(`${apiUrl}/checkout/${pageId}/charges`, token, {
    body: JSON.stringify(data),
    method: 'POST',
  });
}

function initializeSubscription(data, token = null) {
  return request(`${apiUrl}/subscriptions/initialize`, token, {
    body: JSON.stringify(data),
    method: 'POST',
  });
}

function confirmSubscription(data, token = null) {
  return request(`${apiUrl}/subscriptions/confirm`, token, {
    body: JSON.stringify(data),
    method: 'POST',
  });
}

function getChargeByClientSecret(clientSecret) {
  return request(`${apiUrl}/charges/client-secret/${clientSecret}`);
}

function validateCoupon(body, pageId, sellerId) {
  return request(`${apiUrl}/checkout/sellers/${sellerId}/pages/${pageId}/validate-coupon`, null, {
    body: JSON.stringify(body),
    method: 'POST',
  });
}

function getCouponByStripeCouponId(stripeCouponId, sellerId) {
  return request(
    `${apiUrl}/checkout/sellers/${sellerId}/get-coupon-by-stripe-coupon-id/${stripeCouponId}`,
    null,
    {
      method: 'GET',
    },
  );
}

function getPaymentStatus(id, sessionId) {
  return request(`${apiUrl}/checkout/payments/${id}/status?${stringify({ sessionId })}`);
}

function getSubscriptionStatus(id, sessionId) {
  return request(`${apiUrl}/checkout/subscriptions/${id}/status?${stringify({ sessionId })}`);
}

function getCheckout(sellerId, pageId, params = {}, token) {
  return suspenseFetcher(
    `/checkout/sellers/${sellerId}/pages/${pageId}?${stringify(params)}`,
    token,
  );
}

function calculateTax(body, sellerId, pageId) {
  return fetcher(`/checkout/sellers/${sellerId}/pages/${pageId}/calculate-tax`, null, {
    body: JSON.stringify(body),
    method: 'POST',
  });
}

export async function calculateProration(body, sellerId, pageId) {
  return fetcher(`/checkout/sellers/${sellerId}/pages/${pageId}/calculate-proration`, null, {
    body: JSON.stringify(body),
    method: 'POST',
  });
}

function getSubmission(submissionId, sessionId) {
  return fetcher(`/checkout/submissions/${submissionId}?${stringify({ sessionId })}`);
}

function getCharge(paymentId, sessionId) {
  return fetcher(`/checkout/payments/${paymentId}?${stringify({ sessionId })}`);
}

function getSubscription(paymentId, sessionId) {
  return fetcher(`/checkout/subscriptions/${paymentId}?${stringify({ sessionId })}`);
}

function getCountryCode() {
  return fetcher(`/checkout/country-code`);
}

function getBookingGuests(paymentId, sessionId) {
  return fetcher(`/checkout/payments/${paymentId}/guests?${stringify({ sessionId })}`);
}

function saveBookingGuest(paymentId, sessionId, position, guest) {
  return fetcher(
    `/checkout/payments/${paymentId}/guests/${position}?${stringify({ sessionId })}`,
    null,
    {
      body: JSON.stringify(guest),
      method: 'POST',
    },
  );
}

function setPaymentError(paymentError, id) {
  return request(`${apiUrl}/charges/${id}/error`, null, {
    body: JSON.stringify({ paymentError, sessionId: getSessionId() }),
    method: 'POST',
  });
}

function setSubscriptionError(paymentError, id) {
  return request(`${apiUrl}/subscriptions/${id}/error`, null, {
    body: JSON.stringify({ paymentError, sessionId: getSessionId() }),
    method: 'POST',
  });
}

function getTemplateByPageId(pageId) {
  return fetcher(`/checkout/template-by-page-id/${pageId}`);
}

function createOrUpdateCheckoutEvent(pageId, data, checkoutEventId, token = null) {
  return request(
    `${apiUrl}/checkout/${pageId}/checkout-event?checkoutEventId=${checkoutEventId}`,
    token,
    {
      body: JSON.stringify(data),
      method: 'POST',
    },
  );
}

function getCheckoutEventById(pageId, checkoutEventId) {
  return fetcher(`/checkout/${pageId}/checkout-event?checkoutEventId=${checkoutEventId}`);
}

export default {
  getBookingGuests,
  saveBookingGuest,
  getCheckout,
  createSubmission,
  createPayment,
  initializeSubscription,
  confirmSubscription,
  getChargeByClientSecret,
  validateCoupon,
  getCouponByStripeCouponId,
  getPaymentStatus,
  getSubscriptionStatus,
  setPaymentError,
  setSubscriptionError,
  getSubmission,
  getCharge,
  getSubscription,
  getCountryCode,
  calculateTax,
  getTemplateByPageId,
  calculateProration,
  createOrUpdateCheckoutEvent,
  getCheckoutEventById,
};
